import { throttle } from 'lodash';

// leading 是否在时间段开始时执行（默认为 true）
// trailing 是否在时间段结束时执行（默认为 true）
const throttleOptions = {
  leading: true,
  trailing: false
};
export const throttleAction = (fn) => {
  return throttle(fn, 1000, throttleOptions);
};

// 统一添加节流
export function initThrottledJump() {
  // 保存原始方法
  const originalMethods = {
    push: window.app.router.push,
    replace: window.app.router.replace
  };

  // 创建节流后的方法
  const throttledMethods = {
    push: throttle(
      (options) => {
        originalMethods.push(options);
      },
      500,
      throttleOptions
    ),
    replace: throttle(
      (options) => {
        originalMethods.replace(options);
      },
      500,
      throttleOptions
    )
  };

  // 重写 window.app.router 的路由方法
  Object.keys(throttledMethods).forEach((method) => {
    window.app.router[method] = throttledMethods[method];
  });
}



// WEBPACK FOOTER //
// ./src/utils/throttledJump.js